import React from 'react';
import PropTypes from 'prop-types';
import DrawerManager from 'components/Shared/Drawers/DrawerManager';
import ModalManager from 'components/Shared/Modals/ModalManager';
import Listeners from 'components/Listeners';
import Favicon from 'components/Layouts/Favicon/container';
import PageTitle from 'components/Layouts/PageTitle/container';
import { GlobalError } from 'components/Shared/Errors/container';

import FullscreenLoader from 'components/Shared/Layout/FullscreenLoader';
import { StyledInterface, GlobalStyle } from 'components/Shared/style';

const PageLayout = ({
    drawerType,
    _currentUser,
    modalType,
    className = 'interface',
    children,
    hasError,
    isLoading
}) => {
    const common = (
        <>
            <Favicon />
            <PageTitle />
            <Listeners />
            <GlobalStyle />
        </>
    );

    if (hasError) {
        return (
            <>
                {common}
                <GlobalError />
            </>
        );
    }

    if (isLoading) {
        return (
            <>
                {common}
                <FullscreenLoader />
            </>
        );
    }
    return (
        <>
            {common}
            <StyledInterface className={className}>
                {children}
            </StyledInterface>
            <DrawerManager type={drawerType} />
            {_currentUser && <ModalManager type={modalType} _currentUser={_currentUser} />}
        </>
    );
};

PageLayout.propTypes = {
    children: PropTypes.any.isRequired,
    drawerType: PropTypes.string,
    modalType: PropTypes.string,
    _currentUser: PropTypes.string,
    className: PropTypes.string,
    hasError: PropTypes.bool,
    isLoading: PropTypes.bool
};

export default PageLayout;
